var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 22V2H12V8.5L16.5 13V22H22Z",
    fill: "#1C1B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2V22H12.5V15L8 10.5V2H2Z",
    fill: "#1C1B1E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 2C11.25 1.58579 11.5858 1.25 12 1.25H22C22.4142 1.25 22.75 1.58579 22.75 2V22C22.75 22.4142 22.4142 22.75 22 22.75H16.5C16.0858 22.75 15.75 22.4142 15.75 22V13.3107L11.4697 9.03033C11.329 8.88968 11.25 8.69891 11.25 8.5V2ZM12.75 2.75V8.18934L17.0303 12.4697C17.171 12.6103 17.25 12.8011 17.25 13V21.25H21.25V2.75H12.75Z",
    fill: "#1C1B1E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25 2C1.25 1.58579 1.58579 1.25 2 1.25H8C8.41421 1.25 8.75 1.58579 8.75 2V10.1893L13.0303 14.4697C13.171 14.6103 13.25 14.8011 13.25 15V22C13.25 22.4142 12.9142 22.75 12.5 22.75H2C1.58579 22.75 1.25 22.4142 1.25 22V2ZM2.75 2.75V21.25H11.75V15.3107L7.46967 11.0303C7.32902 10.8897 7.25 10.6989 7.25 10.5V2.75H2.75Z",
    fill: "#1C1B1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLand);
export default __webpack_public_path__ + "static/media/Land.582771f5.svg";
export { ForwardRef as ReactComponent };